<template>
  <div>
    <template>
        <div class="form-title">
            <span id="cityHeader" >Add City</span>
        </div>
    </template>
    <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="cityCreate">
        <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
            <div class="col form-group">
                <label class="control-label" for="state" >State:</label>
                <input type="text" class="form-control" v-model="state" id="state" placeholder="State" name = "state" disabled>
                <!-- <div class="field-error">{{code_error_msg}}</div> -->
            </div>
            <div class="col form-group">
                <label class="control-label" for="city">City:</label>
                <input type="text" class="form-control" v-model="city" id="city" placeholder="City"  name = "city">
                 <div class="field-error">{{city_error_msg}}</div>
            </div>
        </div>
        <div class="btn-groups">
          <button type="submit" id="CreateTermBtn"  class="btn btn-primary" v-on:click.prevent="SaveCity" >
            <i class="fp-save"> </i>  Add
          </button>

          <button type="submit" id="cancelTermBtn" class="btn btn-tertiary" v-on:click.prevent="BackCity" >
          <i class="fp-close"> </i>  Cancel
          </button>
        </div>
    </form>
  </div>
</template>



<script>


import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "CityCreate",
  data() {
    return {
      state:this.$parent.state.text,
      city:"",
      city_error_msg:""
    }
  },
  mounted: function(){
    var self = this;

    var userObj = localStorage.getItem("user_obj");


    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        this.userRole = userJson.roles[0].name;
        this.loggedinUserId = userJson.id;
      }


    }
  },
  methods: {

   SaveCity() {

      var self = this;
      self.city_error_msg = "";
      if (!self.city || self.city == null || self.city == "") {
          self.city_error_msg = "City Required.";
          return;
      }

      $.ajax({
          url: process.env.ROOT_API + "/city/create",
          type: "POST",
          data: {
            city: self.city,
            stateid: this.$parent.state.value,
            user_id: self.loggedinUserId
          },
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            
              if (data.status == "success") {
                  self.$parent.canAddCity = false;
                  self.$emit('populateCityId',data.content);
              } else if ( data.status == "error" ) {
                  self.city_error_msg = "City name already added.";
              }
          },
          error: function (jqXHR, exception) {
              self.generateStatusCodeMessage(jqXHR,true,'city')
          }
      });
   },
   BackCity(){
       var self = this;
       self.$parent.canAddCity = false;
   }
  },
};

</script>



// WEBPACK FOOTER //
// src/components/CityCreate.vue